import { type Canvas, FabricImage } from "fabric";
import { ASSET_LAYER_TYPE } from "../constants.ts";
import type { AssetLayer, CanvasSize } from "../types.ts";
import { createLayer } from "./layer.ts";

export const createAssetLayer = ({
  fabricCanvas,
  canvasSize,
  assetUuid,
}: {
  fabricCanvas: Canvas;
  canvasSize: CanvasSize;
  assetUuid: string;
}) => {
  const assetLayer = new FabricImage(new Image(), {
    left: canvasSize.width / 2,
    top: canvasSize.height / 2,
    width: undefined,
    height: undefined,
    angle: 0,
    crossOrigin: "anonymous",
    originX: "center",
    originY: "center",
  }) as AssetLayer;

  assetLayer.assetUuid = assetUuid;
  assetLayer.displayScale = 1;

  return createLayer({
    fabricCanvas,
    layer: assetLayer,
    name: "Generated Image",
    layerType: ASSET_LAYER_TYPE,
    positionIndex: 0,
  });
};
